import i18n from "i18next";

export const transformSomeErrorMessages = (errorMessage) => {
  if (errorMessage.indexOf('INSUFFICIENT_QUOTA_TO_PERFORM_OPERATION') >= 0) {
    return i18n.t("Insufficient quota to perform this operation");
  }
  return errorMessage;
};